// extracted by mini-css-extract-plugin
module.exports = {"paidPlaces":"_c99540a","label":"_6d288aa","value":"_eaea967"};